import { FC, PropsWithChildren } from "react";
import * as Styled from "./DesktopBodyWrapper.styled";

export interface DesktopBodyWrapperProps {
    verticalCenter?: boolean;
    InfoBanners: React.ComponentType;
    BackgroundImage?: any;
}

export const DesktopBodyWrapper: FC<PropsWithChildren & DesktopBodyWrapperProps> = ({
    verticalCenter,
    children,
    BackgroundImage,
    InfoBanners,
}) => {
    return (
        <Styled.Wrapper
            id="desktop-content-layout-body"
            verticalCenter={verticalCenter}
            hasBackgroundImage={!!BackgroundImage}
        >
            <InfoBanners />
            {children}
        </Styled.Wrapper>
    );
};
